module.exports = __webpack_public_path__ + "img/rightArrow.de754831.svg";